import { notification, Select } from "antd";
import React, { forwardRef } from "react";
import { useHttp } from "../../../../../../hooks/http";
import { URL_API } from "../../../../../../utils";

const SelectProductDistributionType = (props) => {
  const [loading, data, error] = useHttp(
    {
      url: `${URL_API}/system/master/distribution_type`,
      token: true,
    },
    []
  );

  if (error) {
    notification.error({
      description: error,
      placement: "bottomRight",
    });
  }

  return (
    <Select loading={loading} placeholder="รูปแบบการขาย" {...props}>
      {data &&
        data.data &&
        data.data.map((n, i) => (
          <Select.Option key={i} value={n.code}>
            {n.name}
          </Select.Option>
        ))}
    </Select>
  );
};

export default forwardRef((props, ref) => {
  return <SelectProductDistributionType forwardRef={ref} {...props} />;
});
